module.exports = "<th>Наличие на участке</th>\n<td>\n  <div class=\"filter__button-group\">\n    <term\n       source=\"source.electricity\"\n       behavior=\"checkbox\"\n       text=\"Электричество\"/>\n\n    <term\n      source=\"source.gas\"\n      behavior=\"checkbox\"\n      text=\"Газ\"/>\n\n    <term\n      source=\"source.has_drainage\"\n      behavior=\"checkbox\"\n      text=\"Канализация\"/>\n\n    <term\n      source=\"source.has_water\"\n      behavior=\"checkbox\"\n      text=\"Водоснабжение\"/>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/on_site.html
// module id = 350
// module chunks = 0